export enum Environment {
  testRunner = "test-runner",
  development = "development",
  test = "test",
  staging = "staging",
  production = "production",
}
